import transpose from "./transpose";

export default function() {
  return transpose(arguments);
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-array/src/zip.js
// module id = fzZX
// module chunks = 0